import { Component, type ErrorInfo, type ReactNode } from 'react';
import { AlertTriangle, RotateCcw } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface Props {
  children: ReactNode;
}
interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = { error: null };

  public static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  public componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Unbehandelter Anwendungsfehler', error, info.componentStack);
  }

  public render(): ReactNode {
    if (!this.state.error) return this.props.children;
    return (
      <main className="grid min-h-dvh place-items-center bg-canvas p-6 text-ink">
        <section className="w-full max-w-md rounded-2xl border border-danger/25 bg-surface p-6 shadow-soft">
          <div className="mb-4 grid size-11 place-items-center rounded-xl bg-danger/10 text-danger">
            <AlertTriangle aria-hidden="true" className="size-5" />
          </div>
          <h1 className="font-display text-2xl font-bold">Etwas ist schiefgelaufen</h1>
          <p className="mt-2 text-sm leading-relaxed text-muted">
            Deine lokalen Daten bleiben erhalten. Lade die Oberfläche neu; falls der Fehler bleibt,
            exportiere in den Einstellungen ein Backup.
          </p>
          <Button className="mt-5 w-full" onClick={() => window.location.reload()}>
            <RotateCcw aria-hidden="true" className="size-4" /> Neu laden
          </Button>
        </section>
      </main>
    );
  }
}
